import ModuleModelCommon from 'common/models/module';

export default class ModuleModel extends ModuleModelCommon {}

// DO NOT DELETE: this is how TypeScript knows how to look up your models.
declare module 'ember-data/types/registries/model' {
  export default interface ModelRegistry {
    module: ModuleModel;
  }
}
